import { IAppState } from 'spw-redux/reducer';

export const selectUsersItems = (state: IAppState) =>
  state.usersReducer.list.items;

export const selectTotalUsers = (state: IAppState) =>
  state.usersReducer.totalUsers;

export const selectUsersLoading = (state: IAppState) =>
  state.usersReducer.list.loading;

export const selectSelectedUser = (state: IAppState) =>
  state.usersReducer.selectedUser;

export const selectTeamsForSelectedUserList = (state: IAppState) =>
  state.usersReducer.teamsForSelectedUserList;

export const selectProjectsForSelectedUserList = (state: IAppState) =>
  state.usersReducer.projectsForSelectedUserList;

export const selectReportsForSelectedUserList = (state: IAppState) =>
  state.usersReducer.reportsForSelectedUserList;
